import React from 'react';
import logo from "@assets/svg/logo.svg";
import Lottie from "react-lottie";
import locationFailed from "@assets/animations/locationFailed.json";
import {useTranslation} from "react-i18next";

const LocationOutsidePremisses = () => {
  const {t} = useTranslation();
  return (
    <div className='flex flex-col items-center justify-center align-middle'>
      <img alt="logo" className="mt-10 h-10" src={logo}/>
      <div className="rounded-md text-center mt-10">
        <h1 className="font-bold text-gray-900 text-2xl px-4">
          {t('weWereNotAbleToCompleteYourOrderProcess')}.
        </h1>
        <div className="mt-15 justify-around align-middle mx-9">
          <Lottie
            height={300}
            width={300}
            options={{
              loop: true,
              autoplay: true,
              animationData: locationFailed,
              rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
              }
            }}
          />
          <p className="w-full my-5 font-normal text-md text-gray-600">
            {t('clientMustBeInsideDefinedZones')}. {t('pleaseTryAgainWhenVisitingOurBusiness')}.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LocationOutsidePremisses;
